import { Injectable, inject } from '@angular/core';
import {
  Firestore,
  collection,
  collectionData,
  doc,
  query,
  updateDoc,
  serverTimestamp,
  where,
} from '@angular/fire/firestore';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { Observable } from 'rxjs';
import { Bloqueo } from '../models/bloqueo.model';

export interface CrearBloqueoPayload {
  residencialId: string;
  espacioId:     string;
  titulo:        string;
  tipo:          string;
  descripcion?:  string;
  fechaInicio:   string;   // ISO UTC
  fechaFin:      string;   // ISO UTC
  diaCompleto:   boolean;
}

export interface CrearBloqueoResult {
  bloqueoId:          string;
  reservasCanceladas: number;
}

@Injectable({ providedIn: 'root' })
export class BloqueoService {
  private firestore = inject(Firestore);
  private functions = inject(Functions);

  private col(residencialId: string) {
    return collection(this.firestore, `residenciales/${residencialId}/bloqueos`);
  }

  getAll(residencialId: string): Observable<Bloqueo[]> {
    return collectionData(this.col(residencialId), { idField: 'id' }) as Observable<Bloqueo[]>;
  }

  /** Listener acotado a un espacio específico: solo bloqueos activos. */
  getBloqueosActivosByEspacio(residencialId: string, espacioId: string): Observable<Bloqueo[]> {
    const q = query(
      this.col(residencialId),
      where('espacioId', '==', espacioId),
      where('activo',    '==', true)
    );
    return collectionData(q, { idField: 'id' }) as Observable<Bloqueo[]>;
  }

  async crearBloqueo(payload: CrearBloqueoPayload): Promise<CrearBloqueoResult> {
    const fn = httpsCallable<CrearBloqueoPayload, CrearBloqueoResult>(this.functions, 'crearBloqueo');
    const result = await fn(payload);
    return result.data;
  }

  async desactivar(residencialId: string, bloqueoId: string): Promise<void> {
    await updateDoc(doc(this.firestore, `residenciales/${residencialId}/bloqueos/${bloqueoId}`), {
      activo:    false,
      updatedAt: serverTimestamp(),
    });
  }
}
